import { render } from "./BasePageTitle.vue?vue&type=template&id=5da4cfa4"
import script from "./BasePageTitle.vue?vue&type=script&lang=js"
export * from "./BasePageTitle.vue?vue&type=script&lang=js"

import "./BasePageTitle.vue?vue&type=style&index=0&id=5da4cfa4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BasePageTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5da4cfa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5da4cfa4', __exports__)) {
    api.reload('5da4cfa4', __exports__)
  }
  
  module.hot.accept("./BasePageTitle.vue?vue&type=template&id=5da4cfa4", () => {
    api.rerender('5da4cfa4', render)
  })

}


export default __exports__